import React, { useEffect, useReducer } from 'react';
import { useQuery } from '@apollo/client';
import { PageContainer } from '@ant-design/pro-layout';
import { useParams } from 'react-router';
import { GET_REPORT_SUBMISSION } from 'gql/reportSubmissions';
import ProjectHeader from 'components/project/ProjectHeader';
import ErrorPage from 'components/layout/ErrorPage';
import ReportSubmissionSteps from './components/ReportSubmissionSteps';
import ResultReportSubmission from './components/ResultReportSubmission';
import SubmitReport from './components/SubmitReport';
import ReviewReport from './components/ReviewReport';

const Detail = ({ step, reducer }) => {
  switch (step) {
    case 0:
      return <SubmitReport reducer={reducer} />;
    case 1:
      return <ReviewReport reducer={reducer} />;
    case 2:
      return <ResultReportSubmission />;
    default:
      return <ErrorPage errorCode={404} title="Report Submission not found" />;
  }
};

const initialState = { step: null };
const reducer = (_state, action) => {
  switch (action.type) {
    case 'SUBMIT':
      return { step: 0 };
    case 'REVIEWING':
      return { step: 1 };
    case 'COMPLETED':
      return { step: 2 };
    default:
      return initialState;
  }
};

const ReportSubmission = () => {
  const { id, projectId } = useParams();
  const { data, loading } = useQuery(GET_REPORT_SUBMISSION, {
    variables: {
      ids: [id],
    },
  });
  const [state, dispatch] = useReducer(reducer, initialState);
  useEffect(() => {
    if (!loading) {
      const status = data?.reportSubmissions[0]?.status;
      switch (status) {
        case 'SCHEDULED':
          dispatch({ type: 'SUBMIT' });
          break;
        case 'REVIEWING':
          dispatch({ type: 'REVIEWING' });
          break;
        case 'COMPLETED':
          dispatch({ type: 'COMPLETED' });
          break;
        default:
          break;
      }
    }
  }, [loading, data]);

  if (!loading && data.reportSubmissions.length === 0) {
    return (
      <ProjectHeader>
        <PageContainer>
          <ErrorPage
            backPage={`/projects/${projectId}/report-submissions`}
            backButtonText="Back to project's Report Submissions"
            subTitle="Sorry, the Report Submission you visited does not exist."
          />
        </PageContainer>
      </ProjectHeader>
    );
  }

  return (
    <ProjectHeader>
      <PageContainer loading={loading}>
        {!loading && state.step !== null && (
          <>
            <ReportSubmissionSteps current={state.step} />
            <Detail step={state.step} reducer={{ dispatch }} />
          </>
        )}
      </PageContainer>
    </ProjectHeader>
  );
};

export default ReportSubmission;
